/**
 * Groups notifications by time periods
 * Returns an array of groups with labels and notifications
 */
export const groupNotificationsByTime = (notifications) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  const lastWeek = new Date(today);
  lastWeek.setDate(lastWeek.getDate() - 7);

  const groups = {
    today: { label: 'Today', notifications: [] },
    yesterday: { label: 'Yesterday', notifications: [] },
    thisWeek: { label: 'This Week', notifications: [] },
    older: { label: 'Older Notifications', notifications: [] }
  };

  notifications.forEach((notification) => {
    const notificationDate = new Date(notification.createdAt);
    const notificationDay = new Date(
      notificationDate.getFullYear(),
      notificationDate.getMonth(),
      notificationDate.getDate()
    );

    if (notificationDay.getTime() === today.getTime()) {
      groups.today.notifications.push(notification);
    } else if (notificationDay.getTime() === yesterday.getTime()) {
      groups.yesterday.notifications.push(notification);
    } else if (notificationDate >= lastWeek) {
      groups.thisWeek.notifications.push(notification);
    } else {
      groups.older.notifications.push(notification);
    }
  });

  // Return only groups that have notifications
  return Object.values(groups).filter((group) => group.notifications.length > 0);
};
